var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menu-card',{attrs:{"title":_vm.menuItem.itemAltName || _vm.menuItem.itemName,"imageUrl":_vm.menuItem.imagePath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }